import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/component/navbar';

const ILLO_CSS = `
.scn-stage{position:relative;width:100%;min-height:540px;display:flex;align-items:center;justify-content:center;overflow:hidden}
.scn-stage .glow{position:absolute;border-radius:50%;filter:blur(72px);opacity:.5}
.scn-stage .glow.g1{width:360px;height:360px;background:#FBBF24;top:4%;left:-14%;animation:scn-glow 7s ease-in-out infinite}
.scn-stage .glow.g2{width:300px;height:300px;background:#FDE68A;bottom:-4%;right:-12%;animation:scn-glow 9s ease-in-out infinite reverse}
.scn-stage .grid{position:absolute;inset:0;background-image:radial-gradient(rgba(176,125,0,.16) 1px,transparent 1px);background-size:22px 22px;opacity:.6;animation:scn-drift 28s linear infinite}
.scn-card{position:relative;width:330px;background:#fff;border:1px solid #F0E6CC;border-radius:20px;box-shadow:0 32px 64px -26px rgba(120,85,0,.5);padding:22px 22px 18px;transform:rotate(-2deg);animation:scn-rise .7s cubic-bezier(.2,.8,.2,1) both,scn-float 6.5s ease-in-out 1s infinite}
.scn-card .sheen{position:absolute;inset:0;border-radius:20px;overflow:hidden;pointer-events:none}
.scn-card .sheen::after{content:'';position:absolute;top:0;left:-60%;width:45%;height:100%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.6),transparent);transform:skewX(-18deg);animation:scn-sheen 6s ease-in-out 1.8s infinite}
.scn-head{display:flex;align-items:center;gap:10px;margin-bottom:18px}
.scn-ic{width:38px;height:38px;border-radius:11px;background:linear-gradient(135deg,#FDE68A,#F59E0B);display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 7px 15px -6px rgba(245,158,11,.75)}
.scn-ic svg{width:21px;height:21px;stroke:#fff;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.scn-eyebrow{font-size:10px;font-weight:800;letter-spacing:.14em;color:#B07D00;text-transform:uppercase}
.scn-sub{font-size:11px;color:#9aa0ab;font-weight:600;margin-top:1px}
.scn-uae{margin-left:auto;font-size:10px;font-weight:800;color:#8a6400;background:#FFF3D1;border:1px solid #F3DFA0;padding:3px 9px;border-radius:999px}
.scn-label{font-size:10.5px;font-weight:800;letter-spacing:.1em;color:#b3b9c4;text-transform:uppercase;margin-bottom:5px}
.scn-name{font-size:23px;font-weight:800;color:#17263A;line-height:1.18;min-height:28px;word-break:break-word;letter-spacing:-.01em}
.scn-name .ph{color:#cfd4dc}
.scn-caret{display:inline-block;width:2px;height:.92em;background:#F59E0B;margin-left:2px;vertical-align:-2px;animation:scn-blink 1.05s step-end infinite}
.scn-meta{display:flex;gap:8px;margin:15px 0 16px}
.scn-meta i{height:8px;border-radius:6px;background:#F2EEE3;display:block}
.scn-foot{display:flex;align-items:flex-end;justify-content:space-between;gap:12px;padding-top:13px;border-top:1px dashed #EBE2CC}
.scn-sig small{font-size:10.5px;color:#9aa0ab;font-weight:700;letter-spacing:.05em;text-transform:uppercase}
.scn-sig b{display:block;font-family:'Brush Script MT','Segoe Script',cursive;font-size:20px;color:#17263A;font-weight:400;transform:rotate(-3deg);margin-top:2px}
.scn-seal{width:58px;height:58px;flex-shrink:0;animation:scn-seal-in .7s cubic-bezier(.2,1.35,.45,1) 1.05s both}
.scn-seal .tick{transform-origin:29px 29px;animation:scn-spin 16s linear infinite}
.scn-chip{position:absolute;display:flex;align-items:center;gap:7px;background:#fff;border:1px solid #F0E6CC;border-radius:12px;padding:8px 12px;box-shadow:0 14px 30px -14px rgba(120,85,0,.4);font-size:12px;font-weight:700;color:#17263A;white-space:nowrap}
.scn-chip svg{width:16px;height:16px}
.scn-chip.a{top:14%;left:6%;animation:scn-rise .6s cubic-bezier(.2,.8,.2,1) .5s both,scn-floatA 5s ease-in-out 1.2s infinite}
.scn-chip.b{bottom:17%;left:3%;animation:scn-rise .6s cubic-bezier(.2,.8,.2,1) .7s both,scn-floatB 5.6s ease-in-out 1.4s infinite}
.scn-chip.c{top:24%;right:5%;animation:scn-rise .6s cubic-bezier(.2,.8,.2,1) .6s both,scn-floatB 4.6s ease-in-out 1s infinite}
.scn-coin{width:22px;height:22px;border-radius:50%;background:linear-gradient(135deg,#FDE68A,#F59E0B);display:flex;align-items:center;justify-content:center;color:#fff}
.scn-coin svg{width:13px;height:13px}
@keyframes scn-glow{0%,100%{transform:translate(0,0) scale(1);opacity:.5}50%{transform:translate(10px,-12px) scale(1.08);opacity:.65}}
@keyframes scn-drift{to{background-position:22px 22px}}
@keyframes scn-rise{from{opacity:0;transform:translateY(16px) rotate(-2deg)}to{opacity:1}}
@keyframes scn-float{0%,100%{transform:translateY(0) rotate(-2deg)}50%{transform:translateY(-12px) rotate(-2deg)}}
@keyframes scn-floatA{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
@keyframes scn-floatB{0%,100%{transform:translateY(0)}50%{transform:translateY(11px)}}
@keyframes scn-sheen{0%,72%{left:-60%}100%{left:130%}}
@keyframes scn-blink{50%{opacity:0}}
@keyframes scn-seal-in{from{opacity:0;transform:scale(.4) rotate(-40deg)}to{opacity:1;transform:scale(1) rotate(0)}}
@keyframes scn-spin{to{transform:rotate(360deg)}}
@media (prefers-reduced-motion: reduce){.scn-stage *{animation:none !important}}
`;

const CompanyIllustration = ({ name }: { name: string }) => {
  const shown = (name || '').trim();
  return (
    <div className="scn-stage">
      <style>{ILLO_CSS}</style>
      <div className="glow g1" /><div className="glow g2" /><div className="grid" />

      {/* Floating accents */}
      <div className="scn-chip a">
        <span className="scn-coin"><svg viewBox="0 0 24 24"><path d="M5.5 4.2c0-.5.4-.9.9-.9h4.2c4.7 0 7.9 3.3 7.9 8.5s-3.2 8.7-7.9 8.7H6.4c-.5 0-.9-.4-.9-.9V4.2z" fill="none" stroke="currentColor" strokeWidth="2.1"/><line x1="2.5" y1="10.2" x2="16.5" y2="10.2" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round"/><line x1="2.5" y1="14.2" x2="16.5" y2="14.2" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round"/></svg></span>
        License ready
      </div>
      <div className="scn-chip b">
        <svg viewBox="0 0 24 24" fill="none" stroke="#15824E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        Name available
      </div>
      <div className="scn-chip c">
        <svg viewBox="0 0 24 24" fill="#F59E0B"><path d="M12 2l2.2 6.6H21l-5.4 4 2 6.6L12 15.6 6.4 19.2l2-6.6L3 8.6h6.8z"/></svg>
        Brand identity
      </div>

      {/* Trade-license card — shows the live company name */}
      <div className="scn-card">
        <span className="sheen" />
        <div className="scn-head">
          <span className="scn-ic">
            <svg viewBox="0 0 24 24"><path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-3"/><path d="M9 9h.01M9 13h.01M9 17h.01"/></svg>
          </span>
          <div>
            <div className="scn-eyebrow">Trade License</div>
            <div className="scn-sub">Certificate of formation</div>
          </div>
          <span className="scn-uae">UAE</span>
        </div>

        <div className="scn-label">Company name</div>
        <div className="scn-name">
          {shown ? shown : <span className="ph">Your Company Name</span>}
          <span className="scn-caret" />
        </div>

        <div className="scn-meta"><i style={{ width: '46%' }} /><i style={{ width: '30%' }} /></div>

        <div className="scn-foot">
          <div className="scn-sig"><small>Authorized signatory</small><b>Conncct</b></div>
          <svg className="scn-seal" viewBox="0 0 58 58" fill="none">
            <g className="tick">
              {Array.from({ length: 28 }).map((_, i) => (
                <line key={i} x1="29" y1="3" x2="29" y2="8" stroke="#F0C24B" strokeWidth="2" strokeLinecap="round" transform={`rotate(${i * (360 / 28)} 29 29)`} />
              ))}
            </g>
            <circle cx="29" cy="29" r="19" fill="url(#scn-seal-g)" />
            <path d="M21 29.5l5.5 5.5L38 23" stroke="#fff" strokeWidth="3.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
              <linearGradient id="scn-seal-g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#FBBF24" /><stop offset="1" stopColor="#E6920B" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default function SetupCompanyName() {
  const [companyName, setCompanyName] = useState('');
  const navigate = useNavigate();

  const handleNext = () => {
    if (!companyName.trim()) return;
    localStorage.setItem('setupCompanyName', companyName.trim());
    navigate('/setup-emirate');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar hideSignBtn={false} />
      <div className="flex flex-1">
        <div
          className="hidden md:flex w-1/2 items-stretch justify-center"
          style={{ backgroundColor: '#FFFBEB', minHeight: 'calc(100vh - 64px)' }}
        >
          <CompanyIllustration name={companyName} />
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center px-12 py-16">
          <div className="max-w-md">
            <h1 className="text-2xl font-bold text-gray-900 mb-8 leading-snug">
              What is your desired company name?
            </h1>

            <input
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleNext(); }}
              placeholder="Smith's Company"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent text-base"
            />

            <div className="flex items-center gap-4 mt-8">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="px-8 py-3 border-2 border-gray-300 rounded-lg font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
              >
                ← Back
              </button>
              <button
                type="button"
                onClick={handleNext}
                disabled={!companyName.trim()}
                className="px-8 py-3 bg-amber-400 text-gray-900 font-semibold rounded-lg hover:bg-amber-500 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
